/* Evalinne motion - home page + related products on product pages. Skipped if the visitor prefers reduced motion. */
(function () {
  try {
    if (window.__evMotion) return;
    window.__evMotion = 1;
    var p = location.pathname;
    var home = (p === '/' || p === '' || p === '/index');
    var product = /^\/products\//.test(p);
    if (!home && !product) return;
    var d = document, root = d.documentElement;
    if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function ready(f) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', f); else f(); }

    /* ---------- shared: cards revealed progressively WHILE scrolling ---------- */
    function prep(g) {
      var box = g.querySelector('.grid-view-item__image-container');
      var img = box ? box.querySelector('img') : null;
      /* the theme puts 'transition: all' on these: it makes the scrubbed values lag behind the finger */
      g.style.transition = 'none';
      var gv = g.querySelector('.grid-view-item');
      if (gv) gv.style.transition = 'none';
      if (box) box.style.transition = 'none';
      if (img) {
        img.style.transition = 'none';
        var rv = img.parentNode;
        if (rv && rv !== box) rv.style.transition = 'none';
        /* make sure the photo is fetched right away, not lazily */
        try { img.loading = 'eager'; } catch (e) {}
      }
      return { el: g, box: box, img: img, last: -1 };
    }
    /* each card appears in proportion to how far it has been scrolled into view:
       it rises, and its photo is unveiled top-to-bottom while zooming out. */
    function step(cards, vh) {
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i], r = c.el.getBoundingClientRect(), pr;
        if (r.top > vh * 1.1) pr = 0;
        else if (r.bottom < -80) pr = 1;
        else {
          var col = c.el.offsetWidth ? Math.round(c.el.offsetLeft / c.el.offsetWidth) : 0;
          pr = (vh * 1.0 - r.top - col * vh * 0.03) / (vh * 0.2);
          pr = pr < 0 ? 0 : pr > 1 ? 1 : pr;
        }
        if (Math.abs(pr - c.last) < 0.004) continue;
        c.last = pr;
        var e = 1 - Math.pow(1 - pr, 3);
        if (pr >= 1) {
          c.el.style.opacity = '';
          c.el.style.transform = '';
          if (c.box) c.box.style.clipPath = '';
          if (c.img) c.img.style.scale = '';
        } else {
          c.el.style.opacity = Math.min(1, e * 2);
          c.el.style.transform = 'translate3d(0,' + ((1 - e) * 60) + 'px,0) scale(' + (0.97 + 0.03 * e) + ')';
          if (c.box) c.box.style.clipPath = 'inset(0 0 ' + ((1 - e) * 100) + '% 0)';
          if (c.img) c.img.style.scale = (1.35 - 0.35 * e);
        }
      }
    }

    /* ================= PRODUCT PAGE: related products only ================= */
    if (product) {
      ready(function () {
        try {
          var cards = Array.prototype.slice.call(d.querySelectorAll('#shopify-section-related-product .grid__item')).map(prep);
          if (!cards.length) return;
          var ticking = false;
          function frame() { ticking = false; step(cards, window.innerHeight); }
          function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
          window.addEventListener('scroll', kick, { passive: true });
          window.addEventListener('resize', kick);
          kick();
        } catch (e) { /* never break the store */ }
      });
      return;
    }

    /* ================= HOME PAGE ================= */
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('ev-js', 'ev-boot');
    /* safety net: never keep anything hidden for long, even on a slow connection */
    setTimeout(function () { root.classList.remove('ev-boot'); }, 1200);
    setTimeout(function () { root.classList.add('ev-all'); }, 6000);
    ready(function () {
      try { init(); } catch (e) { root.classList.add('ev-all'); root.classList.remove('ev-boot'); if (window.console) console.warn('ev-motion', e); }
    });

    function init() {
      var main = d.getElementById('MainContent');
      if (!main) { root.classList.remove('ev-boot'); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ev-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -4% 0px' });

      function all(sel) { return Array.prototype.slice.call(main.querySelectorAll(sel)); }
      function tag(el, type, delay) {
        if (!el || el.getAttribute('data-ev')) return;
        el.setAttribute('data-ev', type);
        if (delay) el.style.setProperty('--d', delay + 's');
        io.observe(el);
      }
      function split(el) {
        if (!el || el.__evs) return;
        el.__evs = 1;
        el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
        var i = 0;
        (function walk(n) {
          Array.prototype.slice.call(n.childNodes).forEach(function (c) {
            if (c.nodeType === 3) {
              var frag = d.createDocumentFragment();
              c.nodeValue.split(/(\s+)/).forEach(function (part) {
                if (!part) return;
                if (/^\s+$/.test(part)) { frag.appendChild(d.createTextNode(' ')); return; }
                var w = d.createElement('span');
                w.className = 'ev-w';
                w.setAttribute('aria-hidden', 'true');
                part.split('').forEach(function (ch) {
                  var s = d.createElement('span');
                  s.className = 'ev-ch';
                  s.style.setProperty('--i', i++);
                  s.textContent = ch;
                  w.appendChild(s);
                });
                frag.appendChild(w);
              });
              n.replaceChild(frag, c);
            } else if (c.nodeType === 1) { walk(c); }
          });
        })(el);
      }

      /* ---------- hero ---------- */
      all('.hv__title').forEach(function (el) { split(el); tag(el, 'chars', 0.15); });
      all('.hv__text').forEach(function (el) { tag(el, 'blur', 0.7); });
      all('.hv__content a, .hv__content .btn').forEach(function (el) { tag(el, 'zoom', 0.95); });

      /* ---------- headings ---------- */
      all('.section-header .title').forEach(function (el) { tag(el, 'wipe', 0); });
      all('.ev-brand__eyebrow, .ev-testi__eyebrow').forEach(function (el) { tag(el, 'blur', 0); });
      all('.ev-brand__title').forEach(function (el) { tag(el, 'wipe', 0.1); });
      all('.ev-brand__text').forEach(function (el) { tag(el, 'rise', 0.2); });
      all('.ev-brand__cta').forEach(function (el) { tag(el, 'zoom', 0.35); });
      all('.ev-testi__title').forEach(function (el) { split(el); tag(el, 'chars', 0.05); });
      all('.ev-testi__subtitle').forEach(function (el) { tag(el, 'rise', 0.25); });
      all('.ev-testi__track-wrap').forEach(function (el) { tag(el, 'rise', 0.1); });
      all('.hero__inner').forEach(function (el) { tag(el, 'zoom', 0); });

      /* ---------- badges ---------- */
      all('.ev-badge-card').forEach(function (el, i) { tag(el, 'zoom', (i % 4) * 0.12); });
      all('.ev-badge-card__icon').forEach(function (el, i) { tag(el, 'spin', (i % 4) * 0.12 + 0.25); });

      /* ---------- product + blog cards ---------- */
      var cards = [];
      all('.shopify-section').forEach(function (s, si) {
        if (si === 0) return;
        Array.prototype.slice.call(s.querySelectorAll('.grid__item')).forEach(function (g) {
          if (g.closest('.section-header')) return;
          cards.push(prep(g));
        });
      });

      /* ---------- marquee band under the hero ---------- */
      var first = main.querySelector('.shopify-section');
      if (first && !d.querySelector('.ev-marquee')) {
        var items = ['Livraison offerte dès 50 €', 'Retours gratuits 30 jours', '+5 000 clientes satisfaites', 'Paiement sécurisé', 'Jusqu’à -70 % sur la collection hiver'];
        var group = items.map(function (t) { return '<span>' + t + '</span><i>✦</i>'; }).join('');
        var m = d.createElement('div');
        m.className = 'ev-marquee';
        m.setAttribute('aria-hidden', 'true');
        m.innerHTML = '<div class="ev-marquee__track"><div>' + group + '</div><div>' + group + '</div><div>' + group + '</div><div>' + group + '</div></div>';
        first.parentNode.insertBefore(m, first.nextSibling);
      }

      root.classList.remove('ev-boot');

      /* ---------- scroll-linked effects ---------- */
      var bar = d.createElement('div');
      bar.id = 'ev-progress';
      d.body.appendChild(bar);
      var hv = main.querySelector('.hv__video'), hc = main.querySelector('.hv__content'), hvBox = main.querySelector('.hv');
      var ticking = false;
      function frame() {
        ticking = false;
        var y = window.pageYOffset, vh = window.innerHeight;
        var h = Math.max(1, root.scrollHeight - vh);
        bar.style.scale = (y / h) + ' 1';
        if (hvBox && y < hvBox.offsetHeight) {
          if (hv) hv.style.translate = '0 ' + Math.min(y * 0.25, hvBox.offsetHeight * 0.05) + 'px';
          if (hc) {
            hc.style.translate = '0 ' + (y * 0.2) + 'px';
            hc.style.opacity = Math.max(0, 1 - y / (hvBox.offsetHeight * 0.65));
          }
        }
        step(cards, vh);
      }
      function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick);
      kick();

      /* ---------- magnetic buttons (mouse devices only) ---------- */
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        all('.btn, .ev-brand__cta, .coll_button_view').forEach(function (b) {
          b.classList.add('ev-mag');
          b.addEventListener('mousemove', function (e) {
            var r = b.getBoundingClientRect();
            b.style.translate = ((e.clientX - (r.left + r.width / 2)) * 0.22) + 'px ' + ((e.clientY - (r.top + r.height / 2)) * 0.3) + 'px';
          });
          b.addEventListener('mouseleave', function () { b.style.translate = '0 0'; });
        });
      }
    }
  } catch (e) { /* never break the store */ }
})();
